/**
 * Application root -- sets up BrowserRouter routes.
 *
 * Public:    /login
 * Protected: / (dashboard), /resume/:id (editor)
 * CMS:      /cms/* (sites, content library, templates)
 */
import { Routes, Route, Navigate } from 'react-router-dom';
import { ProtectedRoute } from './components/ProtectedRoute';
import { CmsLayout } from './components/cms/CmsLayout';
import { LoginPage } from './pages/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { ResumeEditorPage } from './pages/ResumeEditorPage';
import { SitesListPage } from './pages/cms/SitesListPage';
import { SiteDetailPage } from './pages/cms/SiteDetailPage';
import { PersonalInfoPage } from './pages/cms/PersonalInfoPage';
import { CareerPage } from './pages/cms/CareerPage';
import { SkillsPage } from './pages/cms/SkillsPage';
import { EducationPage } from './pages/cms/EducationPage';
import { CertificatesPage } from './pages/cms/CertificatesPage';
import { PatentsPage } from './pages/cms/PatentsPage';
import { TemplatesPage } from './pages/cms/TemplatesPage';
import { ResumeScorePage } from './pages/cms/ResumeScorePage';
import { CoverLetterPage } from './pages/cms/CoverLetterPage';
import { JobDescriptionParserPage } from './pages/cms/JobDescriptionParserPage';
import { JobDescriptionsListPage } from './pages/cms/JobDescriptionsListPage';

export function App() {
  return (
    <Routes>
      {/* Public route */}
      <Route path="/login" element={<LoginPage />} />

      {/* Protected routes */}
      <Route element={<ProtectedRoute />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/resume/:id" element={<ResumeEditorPage />} />

        {/* CMS routes */}
        <Route path="/cms" element={<CmsLayout />}>
          <Route index element={<Navigate to="/cms/sites" replace />} />
          <Route path="sites" element={<SitesListPage />} />
          <Route path="sites/:id" element={<SiteDetailPage />} />
          <Route path="content/personal-info" element={<PersonalInfoPage />} />
          <Route path="content/career" element={<CareerPage />} />
          <Route path="content/skills" element={<SkillsPage />} />
          <Route path="content/education" element={<EducationPage />} />
          <Route path="content/certificates" element={<CertificatesPage />} />
          <Route path="content/patents" element={<PatentsPage />} />
          <Route path="templates" element={<TemplatesPage />} />
          <Route path="tools/score-resume" element={<ResumeScorePage />} />
          <Route path="tools/cover-letter" element={<CoverLetterPage />} />
          <Route path="tools/parse-job" element={<JobDescriptionParserPage />} />
          <Route path="tools/job-descriptions" element={<JobDescriptionsListPage />} />
        </Route>
      </Route>
    </Routes>
  );
}
